import { makeSceneDoc } from '../kit.js';

/**
 * 房前空地：一切开始的地方。
 * 北边那道锈铁门通向屋里，南边土路通向外面，地上躺着一辆锈死的公交壳子。
 */
export const carportDoc = makeSceneDoc({
  id: 'carport',
  name: '房前空地',
  region: 'suburb',
  tier: 0,
  node: 'carport',
  desc: '屋门外那片踩得发白的黄土，堆着没人要的东西。',
  w: 40, h: 24,
  fill: ':',
  spawn: { gx: 10, gy: 6 },
  draw(b, rng) {
    b.hline(0, 39, 0, '#');                       // 北墙：自家院墙
    b.hline(0, 4, 1, '#');
    b.hline(16, 39, 1, '#');
    b.rect(1, 2, 38, 12, ',');                    // 院子
    b.rect(2, 3, 18, 8, ':');                     // 常停车的空地
    b.rect(22, 3, 16, 6, ',');
    b.rect(0, 15, 40, 9, 'r');                    // 南边出村的土路
    b.scatter(',', 34, { rng, area: [1, 15, 38, 8], only: (c) => c === 'r' });
    b.scatter(':', 20, { rng, area: [1, 2, 38, 12] });
    b.vline(2, 14, 39, ',');
    b.rect(5, 1, 3, 2, '.');                      // 自家屋子：三间宽两进深，门开在南墙正中
    b.set(6, 3, '+');
  },
  props: [
    { type: 'part_bus', gx: 26, gy: 6 },
    { type: 'locked_shed', gx: 33, gy: 3 },
    { type: 'junk_pile', gx: 8, gy: 8 },
    { type: 'junk_pile', gx: 10, gy: 10 },
    { type: 'tire_pile', gx: 13, gy: 5 },
    { type: 'oil_drum', gx: 16, gy: 4 },
    { type: 'broken_cart', gx: 20, gy: 11 },
    { type: 'signpost', gx: 22, gy: 16, state: { kind: 'carport' } },
    { type: 'road_sign', gx: 25, gy: 15 },
  ],
  portals: [
    { to: 'home', gx: 6, gy: 3, spawn: [14, 18], label: '回屋' },
    { to: 'country_road', gx: 20, gy: 22, spawn: [20, 2], label: '出村的土路' },
  ],
});

export default carportDoc;
